import { atom } from 'recoil'
import { ICampaign } from '@/components/Goods/Campaigns/campaigns.types'

const campaignsAtom = atom<ICampaign[]>({ default: [], key: 'etba/campaigns' })
export default campaignsAtom
